export default __webpack_public_path__ + "static/media/subscribe.4fc166f2.png";